import { useLogout } from "Api/Auth";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {resetMenuCount} from "reducers/MenuCount";

const LogOut = () => {
    const { trigger: logout } = useLogout();
    const dispatch = useDispatch();

    const logUserOut = () => {
        logout()
            .then((res) => {
                 dispatch(resetMenuCount());
                window.location = "#/login";
            }).catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        let logoutTimer = setTimeout(() => logUserOut(), 1000);
        return () => {
            clearTimeout(logoutTimer);
        };
    })
    return (
        <h1>Uitloggen. We gaan nu naar de login pagina...</h1>
    )
}

export default LogOut;
